const Errors = {
  addressType: {
    empty: 'Address label is required'
  },
  buildingName: {
    empty: 'Building name is required'
  },
  email: {
    invalid: 'Please enter valid email id'
  },
  firstName: {
    empty: 'Please enter first name'
  },
  lastName: {
    empty: 'Need last name to continue'
  },
  flatNumber: {
    empty: 'Flat number is required'
  },
  localityName: {
    empty: 'Locality is required'
  },
  pinCode: {
    empty: 'Pincode is required',
    length: 'Pin code should contain 6 digits',
    valid: 'Please enter valid pincode'
  },
  otp: {
    empty: 'OTP is required',
    length: 'OTP should contain 4 digits',
    valid: 'Please enter valid OTP'
  },
  phoneNumber: {
    empty: 'Phone number is required',
    length: 'Mobile number should contain 10 digits',
    valid: 'Please enter valid mobile number'
  },
  streetName: {
    empty: 'Street name is required'
  },
  selectedAddressType: {
    empty: 'Need address type to continue'
  }
}

export default Errors
